import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IMenuArray } from 'model'
import { AppThunk } from '../index'
export interface MenuListState {
  menuList: IMenuArray
}

const initialState: MenuListState = {
  menuList: []
}

export const menuListSlice = createSlice({
  name: 'menuList',
  initialState,
  reducers: {
    setMenuListState(state, action: PayloadAction<MenuListState>) {
      state.menuList = action.payload.menuList
    }
  }
})
export const getBreadcrumbAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(false)
  }
}

export default menuListSlice.reducer

export const { setMenuListState } = menuListSlice.actions
